import React from 'react';
import { Button } from 'reactstrap';

interface WarningBodyProps {
    onContinue: () => void;
    ReportName: string;
    ReportTime: string;
}

const IsEditingWarning: React.FC<WarningBodyProps> = ({ onContinue, ReportName, ReportTime }) => (
    <>
        <p>
            <strong>Note:</strong> You are currently editing the report <strong>"{ReportName}"</strong> created at <strong>{ReportTime}</strong>.
        </p>
        <p>
            Creating a new report will revoke the current edit access granted for a submitted report.
            <br />
            Please contact your manager before continuing.
        </p>
        <div className="d-flex justify-content-end gap-3 m-2">
            <Button color="primary" onClick={onContinue}>
                Continue
            </Button>
        </div>
    </>
);

export default IsEditingWarning;
